import { createSlice, current } from '@reduxjs/toolkit';

const createNewCopy = (arr) => {
  let map = [];
  arr.forEach((item, index) => {
    map[index] = Object.assign({}, item);
  });
  return map;
};

export const stationSlice = createSlice({
  name: 'station',
  initialState: {
    favouriteStations: [],
    recentStations: [],
    allStations: [],
    activeStations: [],
    filteredList: [],
    stateSearchList: [],
    isSearching: false,
    isFiltering: false,
    isFirstLoad: true,
    searchByState: '',
    provinceArray: [],
    provinceIdMap: {},
    backup: [],
  },
  reducers: {
    getStations: (state, { payload }) => {
      state.allStations = payload;
      let map = [];
      payload?.forEach((station) => {
        if (station.IsActive) {
          map.push(station);
        }
      });
      state.activeStations = map;
      state.backup = map;
    },
    compareRecentToFavorites: (state) => {
      let favs = createNewCopy(state.favouriteStations);
      let recents = createNewCopy(state.recentStations);

      recents.forEach((stationA) => {
        favs.forEach((stationB) => {
          if (stationA.Id == stationB.Id) {
            stationA.Favorite = stationB.Favorite;
          }
        });
      });

      state.recentStations = recents;
    },
    resetList: (state) => {
      state.allStations = state.backup;
    },
    setStationsTo: (state, { payload }) => {
      state.allStations = payload;
    },
    setProvince: (state, { payload }) => {
      let temp = [...payload];
      state.provinceArray = temp;

      let tempMap = {};
      temp.forEach((province) => {
        tempMap[province.Id] = province;
      });
      state.provinceIdMap = Object.assign({}, tempMap);
    },
    addToFavourites: (state, { payload }) => {
      let map = [...state.allStations];
      let favs = [];

      map.forEach((station) => {
        if (station.Id === payload.Id) {
          station.Favorite = true;
        }
      });

      map.forEach((station) => {
        if (station.Favorite) {
          favs.push(station);
        }
      });

      state.favouriteStations = [...favs];
      state.allStations = [...map];
    },
    removeFromFavorites: (state, { payload }) => {
      let map = [...state.allStations];
      let favs = [...state.favouriteStations];

      map.forEach((station) => {
        if (station.Id === payload.Id) {
          station.Favorite = false;
        }
      });

      favs.forEach((station, index) => {
        if (station.Id === payload.Id) {
          favs.splice(index, 1);
        }
      });

      state.favouriteStations = [...favs];
      state.allStations = [...map];
    },
    setRecentsTo: (state, { payload }) => {
      let map = [...payload];
      let clonedStations = [...state.allStations];
      clonedStations.forEach((stationA) => {
        map.forEach((stationB) => {
          if (stationA.IsActive) {
            if (stationA?.Id === stationB?.Id && stationA.IsActive) {
              stationA.LastListened = stationB.LastListened;
            }
          } else {
            if (stationA?.Id === stationB?.Id) {
              stationB.IsActive = false;
            }
          }
        });
      });
      map.length = 4;
      map = map.filter((entry) => typeof entry != 'undefined');
      state.recentStations = map;
      state.allStations = clonedStations;
    },
    filterRecents: (state) => {
      let recent = [...state.recentStations];
      let map = [...state.allStations];
      let newRecents = [];

      map.forEach((stationA) => {
        recent.forEach((stationB) => {
          if (stationA.Id == stationB.Id) {
            stationA = stationB;
          }
        });
      });

      map
        .filter((station) => station.LastListened !== null)
        .sort((a, b) => b.LastListened.toString().localeCompare(a.LastListened))
        .forEach((station) => {
          newRecents.push(station);
        });
      newRecents.length = 4;
      state.recentStations = newRecents;
    },
    addNewStation: (state, { payload }) => {
      state.allStations = [...state.allStations, payload];
    },
    filterByState: (state, { payload }) => {
      state.searchByState = payload;
      switch (state.searchByState) {
        case 'activo':
          state.stateSearchList = state.allStations.filter(
            (station) => station.IsActive === true,
          );
          state.isFiltering = true;
          break;
        case 'inactivo':
          state.stateSearchList = state.allStations.filter(
            (station) => station.IsActive === false,
          );
          state.isFiltering = true;
          break;
        case '':
          state.stateSearchList = state.allStations;
          state.isFiltering = false;
          break;
      }
    },
    filterByName: (state, action) => {
      let lists = [];
      let filteredStations = [];
      lists = state.allStations;
      for (let station of lists) {
        if (
          station.Name.toLowerCase().includes(
            action.payload.toLowerCase().trim(),
          )
        ) {
          filteredStations.push(station);
        }
      }
      state.filteredList = [...filteredStations];
    },
    filterByNameWithFilterState: (state, { payload }) => {
      let lists = [];
      let filteredStations = [];
      lists = state.stateSearchList;
      for (let station of lists) {
        if (station.Name.toLowerCase().includes(payload.toLowerCase().trim())) {
          filteredStations.push(station);
        }
      }
      state.filteredList = [...filteredStations];
    },
    filterFavoritesByName: (state, action) => {
      let map = [...state.allStations];
      let lists = [...state.favouriteStations];
      let filteredStations = [];
      let realMap = [];

      map.forEach((Astation) => {
        lists.forEach((Bstation) => {
          if (Astation.Id === Bstation.Id) {
            if (!Astation.IsActive) {
              Bstation.IsActive = false;
            }
          }
          filteredStations.push(Bstation);
        });
      });

      for (let station of filteredStations) {
        if (
          station.Name.toLowerCase().includes(
            action.payload.toLowerCase().trim(),
          )
        ) {
          realMap.push(station);
        }
      }

      realMap = realMap.filter(
        (station, index, self) =>
          index === self.findIndex((t) => t.Id === station.Id),
      );
      state.filteredList = [...realMap].filter((station) => station.IsActive);
    },
    setIsSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    setIsFirstLoad: (state, action) => {
      state.isFirstLoad = action.payload;
    },
    setIsFilteringTrue: (state) => {
      state.isFiltering = true;
    },
    setIsFilteringFalse: (state) => {
      state.isFiltering = false;
    },
    updateCurrentPlayingStation: (state, action) => {
      let temp = [...state.allStations];

      temp.forEach((station) => {
        if (station.Id !== action.payload.Id) {
          station.IsPlaying = false;
        }
        if (station.Id === action.payload.Id) {
          if (station.IsPlaying) {
            station.IsPlaying = false;
          } else {
            station.IsPlaying = true;
          }
        }
      });

      state.allStations = temp;
    },
    updateTimeStampOnStationList: (state, action) => {
      let recent = [];
      let map = [...state.allStations];

      for (let i = 0; i < map.length; i++) {
        if (map[i].Id == action.payload.Id) {
          map[i].LastListened = Date.now();
        }
      }

      map
        .filter((station) => station.LastListened !== null)
        .sort((a, b) => b.LastListened.toString().localeCompare(a.LastListened))
        .forEach((station) => {
          if (recent.length < 4) {
            recent.push(station);
          }
        });
      state.recentStations = recent;
    },
    compareAndUpdateFavorites: (state) => {
      let favs = [...state.favouriteStations];
      let map = [...state.allStations];

      favs.forEach((AStation) => {
        map.forEach((BStation) => {
          if (AStation.Id === BStation.Id && BStation.IsActive) {
            BStation.Favorite = true;
          }
        });
      });
      state.allStations = [...map];

      map = [...state.filteredList];
      favs.forEach((AStation) => {
        map.forEach((BStation) => {
          if (AStation.Id === BStation.Id && BStation.IsActive) {
            BStation.Favorite = true;
          }
        });
      });
      state.filteredList = [...map];

      map = [...state.stateSearchList];
      favs.forEach((AStation) => {
        map.forEach((BStation) => {
          if (AStation.Id === BStation.Id && BStation.IsActive) {
            BStation.Favorite = true;
          }
        });
      });
      state.stateSearchList = [...map];
    },
    compareAndUpdateRecents: (state) => {
      let recents = [...state.recentStations];
      let map = [...state.allStations];

      recents.forEach((AStation) => {
        map.forEach((BStation) => {
          if (AStation?.Id === BStation.Id && BStation.IsActive) {
            AStation = BStation;
            BStation.Favorite = false;
          }
        });
      });
      state.allStations = [...map];
    },
    setFavorites: (state, { payload }) => {
      let map = [...payload];
      map.forEach((station) => {
        station.Favorite = true;
      });
      state.favouriteStations = map;
    },
    initFavs: (state) => {
      let map = [];
      state.favouriteStations.forEach((station) => {
        station['Favorite'] = true;
        map.push(station);
      });
      state.favouriteStations = map;
    },
    updateStationById: (state, action) => {
      let map = [...state.allStations];
      for (let i = 0; i < map.length; i++) {
        if (map[i].Id === action.payload.Id) {
          map[i] = action.payload;
        }
      }
      state.allStations = [...map];
    },
    updateFavoriteByIDtoTrue: (state, { payload }) => {
      let map = [...state.allStations];
      let favs = [];
      map.forEach((station) => {
        if (station.Id == payload.Id) {
          station.Favorite = true;
        }
      });

      map.forEach((station) => {
        if (station.Favorite) {
          favs.push(station);
        }
      });

      state.favouriteStations = favs;
      state.allStations = map;
    },
    updateFavoriteByIDtoFalse: (state, { payload }) => {
      let map = [...state.allStations];
      let favs = [];

      map.forEach((station) => {
        if (station.Id === payload.Id) {
          station.Favorite = false;
        }
      });

      map.forEach((station) => {
        if (station.Favorite) {
          favs.push(station);
        }
      });

      state.favouriteStations = favs;
      state.allStations = map;
    },
    stopAllStationsPlaying: (state) => {
      let map = [...state.allStations];

      map.forEach((station) => {
        station.IsPlaying = false;
      });
      state.allStations = map;
    },
    stopAllRecentsPlaying: (state) => {
      let map = [...state.recentStations];
      map.forEach((station) => {
        station.IsPlaying = false;
      });
      state.recentStations = map;
    },
  },
});

export const {
  updateStationToFavourite,
  stopAllStationsPlaying,
  stopAllRecentsPlaying,
  updateStationById,
  getStations,
  initFavs,
  addToFavourites,
  filterRecents,
  addNewStation,
  filterByState,
  filterByName,
  resetList,
  setIsSearching,
  filterFavoritesByName,
  filterByNameWithFilterState,
  removeFromFavorites,
  setIsFirstLoad,
  updateCurrentPlayingStation,
  updateTimeStampOnStationList,
  compareAndUpdateFavorites,
  compareAndUpdateRecentFavs,
  getStastionByID,
  setFavorites,
  updateFavoriteByIDtoFalse,
  updateFavoriteByIDtoTrue,
  setIsFilteringFalse,
  setIsFilteringTrue,
  setRecentsTo,
  setStationsTo,
  compareAndUpdateRecents,
  setProvince,
  compareRecentToFavorites,
} = stationSlice.actions;
export default stationSlice.reducer;
